import { Route, Routes, useParams } from 'react-router-dom';
import { useNavigate } from '../../components/Navigate';
import { articlesOfAssocLinkEdit } from '../../components/Links';
import { useEffect } from 'react';
import { ArticlesOfAssocEdit } from './ArticlesOfAssocEdit';

export const ArticlesOfAssocWithRoutes = () => {
  const { articlesOfAssocId } = useParams();
  const { pathname, navigate } = useNavigate();

  const editLink = articlesOfAssocLinkEdit({ id: articlesOfAssocId! });

  useEffect(() => {
    if (pathname.endsWith(articlesOfAssocId!)) {
      void navigate(editLink, undefined, { replace: true });
    }
  }, [pathname, editLink, navigate, articlesOfAssocId]);

  if (pathname.endsWith(articlesOfAssocId!)) {
    return '';
  }

  return (
    <Routes>
      <Route path="edit" element={<ArticlesOfAssocEdit aoaId={articlesOfAssocId!} />}>
        <Route path="*" element={<ArticlesOfAssocEdit aoaId={articlesOfAssocId!} />} />
      </Route>
    </Routes>
  );
};
